import { render } from "./button-group.vue?vue&type=template&id=19488620&scoped=true"
import script from "./button-group.vue?vue&type=script&lang=js"
export * from "./button-group.vue?vue&type=script&lang=js"

import "./button-group.vue?vue&type=style&index=0&id=19488620&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\67026\\Desktop\\front1.0\\front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19488620"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon,QField});
